import apiHandler from "../apiHandler";

export const getTags = async () => {
    const tags = await apiHandler({
        endpoint: '/tags',
        method: 'GET',
    });

    if (!tags) {
        throw new Error('No tags found');
    }

    return tags;
};